"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var List_1 = require("material-ui/List");
var lodash_1 = require("lodash");
var recompose_1 = require("recompose");
var list_to_tree_lite_1 = __importDefault(require("list-to-tree-lite"));
var IconButton_1 = __importDefault(require("material-ui/IconButton"));
var menu_1 = __importDefault(require("material-ui/svg-icons/navigation/menu"));
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var Breadcrumbs_1 = __importDefault(require("./../Breadcrumbs"));
var styles_1 = __importDefault(require("./styles"));
var SidebarItem_1 = __importDefault(require("./SidebarItem"));
var Sidebar = function (_a) {
    var BreadcrumbsItem = _a.BreadcrumbsItem, // components
    BreadcrumbsComponent = _a.BreadcrumbsComponent, SidebarBottomComponent = _a.SidebarBottomComponent, SidebarCenterComponent = _a.SidebarCenterComponent, children = _a.children, items = _a.items, handleToggleSidebar = _a.handleToggleSidebar, // handlers
    handleToggleItem = _a.handleToggleItem, handleClick = _a.handleClick, logo = _a.logo, // opts
    renderSidebaritem = _a.renderSidebaritem, breadcrumbs = _a.breadcrumbs, uiVersion = _a.uiVersion, apiVersion = _a.apiVersion, versionLabel = _a.versionLabel, showBreadCrumbs = _a.showBreadCrumbs, // bool opts
    isActive = _a.isActive, isOpen = _a.isOpen, togglable = _a.togglable, _b = _a.muiTheme.sidebar, activeItem = _b.activeItem, itemStyle = _b.item, burger = _b.burger, // styles
    styles = _a.styles;
    return (react_1.default.createElement("div", { style: styles.main },
        togglable && (react_1.default.createElement("div", { style: __assign({}, styles.burger, burger), className: "hidden-for-print" },
            react_1.default.createElement(IconButton_1.default, { onClick: handleToggleSidebar, iconStyle: { color: 'black' } },
                react_1.default.createElement(menu_1.default, null)))),
        react_1.default.createElement("div", { style: styles.panel, className: "hidden-for-print" },
            !lodash_1.isEmpty(logo) && (react_1.default.createElement("div", { style: styles.logo },
                react_1.default.createElement("a", { onClick: togglable ? handleToggleSidebar : lodash_1.noop, role: "menuitem", tabIndex: 0, style: styles.logo.a },
                    react_1.default.createElement("img", { src: logo, alt: "logo", style: styles.logo.img })))),
            react_1.default.createElement("div", { style: styles.sidebarWrapper },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(List_1.List, { className: "sidebar", style: styles.sidebar },
                        lodash_1.filter(items, function (i) { return !i.alignRight; }).map(function (item) {
                            return renderSidebaritem(handleClick, isActive, activeItem, itemStyle, item, handleToggleItem);
                        }),
                        SidebarCenterComponent && isOpen && react_1.default.createElement(SidebarCenterComponent, null),
                        react_1.default.createElement("div", { style: styles.sidebarRight }, lodash_1.filter(items, function (i) { return i.alignRight; }).map(function (item) {
                            return renderSidebaritem(handleClick, isActive, activeItem, itemStyle, item, handleToggleItem);
                        })))),
                SidebarBottomComponent && isOpen && react_1.default.createElement(SidebarBottomComponent, null)),
            react_1.default.createElement("div", { style: styles.sidebarVersion },
                uiVersion && react_1.default.createElement("div", null,
                    "UI: ",
                    uiVersion),
                apiVersion && react_1.default.createElement("div", null,
                    "API: ",
                    apiVersion),
                versionLabel && react_1.default.createElement("div", null, versionLabel))),
        react_1.default.createElement("div", { style: styles.container, className: "no-margins-for-print" },
            showBreadCrumbs && react_1.default.createElement(BreadcrumbsComponent, { items: breadcrumbs, ItemComponent: BreadcrumbsItem }),
            children)));
};
exports.default = recompose_1.compose(muiThemeable_1.default(), recompose_1.setPropTypes({
    BreadcrumbsItem: prop_types_1.default.func,
    BreadcrumbsComponent: prop_types_1.default.func,
    SidebarBottomComponent: prop_types_1.default.func,
    SidebarCenterComponent: prop_types_1.default.func,
    children: prop_types_1.default.arrayOf(prop_types_1.default.node),
    items: prop_types_1.default.array,
    breadcrumbs: prop_types_1.default.array,
    renderSidebaritem: prop_types_1.default.func,
    handleToggleSidebar: prop_types_1.default.func,
    handleToggleItem: prop_types_1.default.func,
    handleClick: prop_types_1.default.func,
    logo: prop_types_1.default.string,
    uiVersion: prop_types_1.default.string,
    apiVersion: prop_types_1.default.string,
    versionLabel: prop_types_1.default.string,
    showBreadCrumbs: prop_types_1.default.bool,
    isActive: prop_types_1.default.func,
    togglable: prop_types_1.default.bool,
    withRightIconsOnToggle: prop_types_1.default.bool,
    muiTheme: prop_types_1.default.object,
    styles: prop_types_1.default.object,
}), recompose_1.defaultProps({
    BreadcrumbsItem: undefined,
    BreadcrumbsComponent: Breadcrumbs_1.default,
    SidebarBottomComponent: null,
    SidebarCenterComponent: null,
    children: null,
    items: [],
    breadcrumbs: [],
    renderSidebaritem: SidebarItem_1.default,
    handleToggleSidebar: lodash_1.noop,
    handleToggleItem: lodash_1.noop,
    handleClick: lodash_1.noop,
    logo: '',
    uiVersion: '',
    apiVersion: '',
    versionLabel: '',
    open: true,
    showBreadCrumbs: true,
    isActive: function () { return false; },
    togglable: false,
    withRightIconsOnToggle: false,
    muiTheme: { sidebar: { activeItem: {}, itemStyle: {} } },
    styles: {},
    appBarHeight: 0,
    containerPadding: 20,
    logoStyle: {},
}), recompose_1.withProps(function (_a) {
    var items = _a.items;
    return ({
        originalItems: items,
    });
}), recompose_1.withState('isOpen', 'setOpen', function (_a) {
    var open = _a.open;
    return (!!open ? true : false);
}), recompose_1.withState('stateItems', 'setItems', function (_a) {
    var items = _a.items;
    return items;
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (nextProps) {
        if (!lodash_1.isEqual(nextProps.items, this.props.items)) {
            nextProps.setItems(nextProps.items);
        }
    },
}), recompose_1.renameProp('stateItems', 'items'), recompose_1.withHandlers({
    handleToggleItem: function (_a) {
        var items = _a.items, singleItemToggle = _a.singleItemToggle, setItems = _a.setItems;
        return function (e, id) {
            e.preventDefault();
            var clickedItemIndex = lodash_1.findIndex(items, ['id', id]);
            var clickedItem = lodash_1.find(items, ['id', id]);
            clickedItem.open = !clickedItem.open;
            var newItems = __spread(items);
            if (singleItemToggle) {
                newItems = lodash_1.map(items, function (i) { return (__assign({}, i, { open: false })); });
            }
            newItems[clickedItemIndex] = clickedItem;
            setItems(newItems);
        };
    },
    handleToggleAllItems: function (_a) {
        var items = _a.items, singleItemToggle = _a.singleItemToggle, setItems = _a.setItems;
        return function () {
            var newItems = __spread(items);
            if (singleItemToggle) {
                newItems = lodash_1.map(items, function (i) { return (__assign({}, i, { open: false })); });
            }
            setItems(newItems);
        };
    },
    handleToggleSidebar: function (_a) {
        var originalItems = _a.originalItems, items = _a.items, setOpen = _a.setOpen, setItems = _a.setItems, isOpen = _a.isOpen, withRightIconsOnToggle = _a.withRightIconsOnToggle;
        return function () {
            setOpen(!isOpen);
            if (withRightIconsOnToggle) {
                if (isOpen) {
                    var newItems = lodash_1.filter(items, function (i) { return i.rightIcon; });
                    newItems = lodash_1.map(newItems, function (i) { return ({
                        id: i.id,
                        path: i.path,
                        primaryText: i.primaryText,
                        listItemProps: {
                            rightIcon: i.rightIcon,
                        },
                    }); });
                    setItems(newItems);
                }
                else {
                    setItems(originalItems);
                }
            }
        };
    },
}), recompose_1.withHandlers({
    handleClick: function (_a) {
        var onClick = _a.onClick, handleToggleAllItems = _a.handleToggleAllItems;
        return lodash_1.memoize(function (value) { return function (event) {
            event.preventDefault();
            onClick(value, event);
            if (typeof value.onClick === 'function') {
                value.onClick();
            }
            handleToggleAllItems();
        }; });
    },
}), recompose_1.mapProps(function (_a) {
    var items = _a.items, rest = __rest(_a, ["items"]);
    return (__assign({}, rest, { items: list_to_tree_lite_1.default(items) }));
}), 
// with styles
recompose_1.withProps(function (_a) {
    var panel = _a.muiTheme.sidebar.panel, logo = _a.logo, orientation = _a.orientation;
    return ({
        panelStyle: __assign({}, panel, { logoHeight: lodash_1.isEmpty(logo) ? 0 : panel.logoHeight }),
        isVertical: orientation === 'vertical' || orientation !== 'horizontal',
    });
}), recompose_1.withProps(function (_a) {
    var panelStyle = _a.panelStyle, logoStyle = _a.logoStyle, isOpen = _a.isOpen, appBarHeight = _a.appBarHeight, containerPadding = _a.containerPadding, isVertical = _a.isVertical, withRightIconsOnToggle = _a.withRightIconsOnToggle;
    return ({
        styles: styles_1.default(panelStyle, logoStyle, isOpen, appBarHeight, containerPadding, isVertical, withRightIconsOnToggle),
    });
}))(Sidebar);
//# sourceMappingURL=Sidebar.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/Sidebar/Sidebar.js
// module id = 1841
// module chunks = 0